module.exports = __webpack_public_path__ + "static/pieniadz-bcb358bf2d97cc2714f0449a4edfb35d.jpg";